// Single canonical domain: physiowrld.rs (Serbian). physiowrld.com and the
// secondary domains 301-redirect to it — there is no per-domain language split.
export const SITE_URL = 'https://physiowrld.rs';
export const SERBIAN_SITE_URL = SITE_URL;

export const siteUrlForLanguage = (_language?: string) => SITE_URL;
